export default {
    state: {
        selectedMedia: {}, // Currently selected media
    },
    mutations: {
        setSelectedMedia(state, media) {
            state.selectedMedia = media;
        },
    },
    actions: {
        
    },
    getters: {
        selectedMedia: (state) => state.selectedMedia,
    },
};
